import { AST } from '../../ast';
import _ from 'lodash';
import { exprToEraQLAst } from '../to-eraql-ast/expr-to-eraql-ast';
import { buildNode } from '../formatter/Builder';
import { withNullMeta } from '../lex/types';
import { generateProgram } from '../formatter/Generator';

type Opts = { refs: Record<string, string> };

export const exprToEraQL = (ast: AST.ExprFR, opts: Opts): string => {
  const eraQLAst = exprToEraQLAst(ast, opts);
  const formatNodeTree = buildNode(withNullMeta(eraQLAst));
  return generateProgram(formatNodeTree);
};
